import { Component, OnInit, TemplateRef } from '@angular/core';
import { MailgroupService } from './mailgroup.service';
import { Mailgroup, MailGroupDetails } from './mailgroup';
import { ToastrService } from 'ngx-toastr';
import { User } from '../Master/user/user';
import { UserService } from '../Master/user/user.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { filter } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../Shared/commondialog/commondialog.component';
import { debug } from 'util';
import { Router } from '@angular/router';
import { LocalService } from '../local.service';
declare var $: any;
@Component({
  selector: 'app-mailgroup',
  templateUrl: './mailgroup.component.html',
  styleUrls: ['./mailgroup.component.css']
})
export class MailgroupComponent implements OnInit {
  sendMenuId: number = 4;
  sendPageName: string = 'Mail Groups';
  active: number;
  p: number = 1;
  r: number = 1; q: number = 1;
  public searchTextforUser: string; mailgroupId: number
  itemsPerPage: number = 10; groupName: string; selectedmailid: string; isToSelect:number;
  isCcSelect:number; currentgroup: number; operation: string; selectuserforMapping = false; confmsg: string
  SelectedUsers: MailGroupDetails[] = [];
  mailGroupModalRef: BsModalRef;
  selectedmailgroup: Mailgroup;
  selectedMailGrp: any;
  removeTouched = false;
  mailGroupDetail: MailGroupDetails = new MailGroupDetails();
  MapTouched: boolean = false;
  previousMailGrp: string;
  userMappingConfirmed = false;
  groupnameExist: boolean = false;
  key: string = 'mailgroup'; //set default
  key1: string = 'mailgroup'; //set default
  key2: string = 'mailgroup'; //set default
  reverse = false; mappedlistsort = false; userlistsort = false
  MailGroupMasterForm: FormGroup; mailgroupMappedList: MailGroupDetails[] = [];

  showall: boolean = true;
  showallstatus: boolean = false;

  _actionRights: any; _menuId: any; readOnly: boolean; add: boolean; edit: boolean; delete: boolean; submitShow: boolean;
  searchTextForMailGroup: string;
  maptype: string; selectedIndex: number

  constructor(
    private mailgroupService: MailgroupService,
    private toastr: ToastrService,
    private userService: UserService,
    private bsModelService: BsModalService,
    private formBuilder: FormBuilder,
    private dialogService: DialogService,
    private router: Router,
    private localService: LocalService
  )
  {
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('MailGroup_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('MailGroup_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('MailGroup_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('MailGroup_action');
    }
  }
  mailGroups: Mailgroup[] = [];
  mailGroupsactive: Mailgroup[] = [];
  userslist: User[]
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    this.MailGroupMasterForm = this.formBuilder.group({
      mailgroupid: [''],
      mailgroup: ['', Validators.required],
      active: ['']
    });
    this.getActionRightsList();
    this.getallmailgroup(); this.getUsersList(); this.currentgroup = 0;
    //$('body').addClass('nav-sm').removeClass('nav-md');
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedMailGroups");
    let data = arrays.find(ob => ob['name'] === 'Mail Groups');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedMailGroups","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedMailGroups",null);
      this.router.navigate(["home"]);      
    }
  }

  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  sort(key, typeOfSort) {

    if (typeOfSort === 'mailgroupsort') {
      this.key = key;
      this.reverse = !this.reverse;
    }
    else if (typeOfSort === 'mappedlistsort') {
      this.key1 = key;
      this.mappedlistsort = !this.mappedlistsort;
    }
    else if (typeOfSort === 'userlistsort') {
      this.key2 = key;
      this.userlistsort = !this.userlistsort;
    }
  }

  get g() { return this.MailGroupMasterForm.controls; }

  getallmailgroup() {
    this.mailGroups = [];
    this.mailGroupsactive = [];
    this.mailgroupService.getmailgroups().subscribe(res => {
     
      this.mailGroups = res
      if (this.showallstatus == true) {
        this.mailGroups.forEach(data => {
          if (data.active == 1) {
            this.mailGroupsactive.push(data);
          }
        });
        this.mailGroups = [];
        this.mailGroups = this.mailGroupsactive;
      }
    },
      err => {
        this.toastr.error('Error while getting Mailgroup Data');
      }
    )
  }

  getactiveinactive(showallp) {
    this.mailGroupsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.mailGroups.forEach(data => {
        if (data.active == 1) {
          this.mailGroupsactive.push(data);
        }
      });
      this.mailGroups = [];
      this.mailGroups = this.mailGroupsactive;
    }
    else {
      this.showall = true;
      this.mailGroups = [];
      this.getallmailgroup();
    }
  }

  getMailGroupMappedList(mailgrp) {
    this.selectedMailGrp = mailgrp
    if (this.MapTouched || this.removeTouched) {

      this.OpenConfirmforMapping(mailgrp.mailgroup);

    }
    else {
      this.selectedmailgroup = mailgrp;
      this.groupName = mailgrp.mailgroup;
      if (this.groupName) {
        this.groupnameExist = true;
      }
      this.mailgroupService.GetMailGrpMappedList(mailgrp.mailgroupid).subscribe(res => {
        if (res) {

          this.SelectedUsers = res
          this.SelectedUsers.forEach((data, index) => {
            data.loadedfromdatabase = true
          })

        }

      }, err => {
        this.toastr.error('Not Able to get mapped users');
      })
    }
    // if (this.userMappingConfirmed) {

    //}

  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.active = 1;
    } else {
      this.active = 0
    }
  }

  OpenConfirmTemplate(mailmap, type) {

    if (type == 'mailgrpmaster') {
      if (mailmap.active == 0) {
        this.confmsg = "Are you sure you want to activate this record ?";
      }
      else
        this.confmsg = "Are you sure you want to deactivate this record ?";
    }
    else {
      this.confmsg = "Are you sure you want to remove user ?";
    }

    if (!this.removeTouched || this.removeTouched) {

      let showpopup = this.dialogService.addDialog(CommondialogComponent,
        {
          title: 'Please Confirm',
          message: this.confmsg,
          hclass: 'modelsuccess',
          oktext: 'Yes',
          canceltext: 'No',
          okshow: true,
          cancelshow: true
        }).subscribe((isConfirmed) => {
          if (isConfirmed) {
            //this.government = government;
            if (mailmap['emailid']) {
              this.removeFromMapingList(mailmap);
            }
            else {
              this.Delete(mailmap);
            }


          }

        });
    }
  }

  removeFromMapingList(user) {
    this.removeTouched = true
    this.previousMailGrp = this.groupName;
    //if (user.LoadedFromDatabase) {
    //  if (user.active === 1)
    //    user.active = 0
    //  else if (user.active === 0) {
    //    user.active = 1

    //  }
    //  this.mailgroupService.DeleteUserFromGroup(user).subscribe(res => {
    //    if (res.status == 200) {
    //      this.toastr.success('User removed from the group');
    //      this.getMailGroupMappedList(this.selectedmailgroup);
    //    }
    //  },
    //    err => {
    //      this.toastr.success('Not able to remove user from the group')
    //    }
    //  )
    //}

    //else {

    this.SelectedUsers.splice(this.SelectedUsers.indexOf(user), 1);
    //}
  }

  getUsersList() {
    this.userService.GetActive().subscribe(res => {
      this.userslist = res

    },
      err => {
        this.toastr.error('Error while getting users data')
      })
  }

  OpenMailGrpPopUp(mailgrpPopup: TemplateRef<any>, type, mailgroup?: Mailgroup) {

    if (type == 'update') {
      this.operation = type;
      this.MailGroupMasterForm.controls['mailgroupid'].setValue(mailgroup.mailgroupid);
      this.MailGroupMasterForm.controls['mailgroup'].setValue(mailgroup.mailgroup);
      this.MailGroupMasterForm.controls['active'].setValue(mailgroup.active);
      this.active = mailgroup.active;
    }
    if (type == 'add') {
      this.operation = type;

    }
    if (!this.MapTouched && !this.removeTouched) {
      this.mailGroupModalRef = this.bsModelService.show(mailgrpPopup, this.config);
      const aa = document.getElementsByClassName('modal-content');
      aa[0].classList.remove("modal-content");
    }
  }

  AddMailGroup(mailgrpname) {
    if (this.MailGroupMasterForm.value.mailgroup.trim() === undefined || this.MailGroupMasterForm.value.mailgroup.trim() === "") {
      this.toastr.error("Please enter Mail Group Name")
      return;
    }
    if (this.operation == 'add') {
      let mailgrp = new Mailgroup();
      this.groupName = mailgrpname.mailgroup
      mailgrpname.mailgroupid = 0
      //mailgrpname.createdby = +localStorage.getItem("userid");
      mailgrpname.createdby = +this.localService.getJsonValue("userid");
      this.mailgroupService.AddMailGroup(mailgrpname).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.ngOnInit();
              this.toastr.success('Mail Group added successfully');
              this.mailGroupModalRef.hide();
            }
            else { this.toastr.warning('Mail Group already exists'); }
          }
        };
      },
        err => {
          this.toastr.error('Error while getting users data')
        }
      )
    }
    else if (this.operation == 'update') {
      this.MailGroupMasterForm.value.active = this.active;
      //mailgrpname.modifiedby = +localStorage.getItem("userid");
      mailgrpname.modifiedby = +this.localService.getJsonValue("userid");
      this.mailgroupService.PutMailGroup(mailgrpname).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.mailGroupModalRef.hide();
              this.getallmailgroup();
              this.toastr.success('Mail Group updated successfully');
            }
            else { this.toastr.warning('Record already exists'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");

        })
    }

  }

  Delete(mailgroup: Mailgroup) {


    var msg;
    if (mailgroup.active == 0) {
      mailgroup.active = 1
      msg = "Mail Group activated successfully"
    }
    else {
      mailgroup.active = 0;
      msg = "Mail Group deactivated successfully"
    }
    this.mailgroupService.Delete(mailgroup).subscribe(res => { this.toastr.success(msg); }, error => { this.toastr.error('Error while deleting the Mail Group') })




  }

  selectTo(item, i, type) {
    this.maptype = type;
    this.selectedIndex = i;


    if (item.hasOwnProperty('touserid')) {
      delete item.touserid;
    }
    if (item.hasOwnProperty('ccuserid')) {
      delete item.ccuserid;
    }
    this.userslist.forEach(data => {
      if (data.userid === item.userid) {
        data.touserid = item.userid
      }
    })

    this.isToSelect = item.userid;
    this.isCcSelect = 0;
    //this.selectedmailid = null;
    this.selectedmailid = item.emailid
  }

  selectCc(item, i, type) {
    this.selectedIndex = i;
    this.maptype = type;


    if (item.hasOwnProperty('touserid')) {
      delete item.touserid;
    }
    if (item.hasOwnProperty('ccuserid')) {
      delete item.ccuserid;
    }
    this.userslist.forEach(data => {
      if (data.userid === item.userid) {
        data.ccuserid = item.userid
      }
    })


    this.isCcSelect = item.userid
    this.isToSelect = 0;
    this.selectedmailid = null;
    this.selectedmailid = item.emailid
  }

  MapUserToGroup(user) {
    this.maptype = null;
    this.selectuserforMapping = true;

    if (!this.groupName) {
      this.toastr.warning('Please select a Mail Group for Mapping');
      return;
    }

    if (!this.groupName) {
      this.toastr.warning('Please select a Mail Group for Mapping');
      return;
    }

    if (user.hasOwnProperty('touserid') || user.hasOwnProperty('ccuserid')) {
      user.mailgroup = this.groupName;
      //if (this.isToSelect) {
      //  user.touserid = user.userid;
      //}
      //else if (this.isCcSelect) {
      //  user.ccuserid = user.userid;
      //}
      user.mailgroupid = this.mailgroupId

      const index = this.SelectedUsers.findIndex(obj => obj.emailid === user.emailid);

      if (index === -1) {
        if (this.isToSelect == user.userid || this.isCcSelect == user.userid) {
          if (this.isToSelect > 0)
            user.touserid = user.userid;
          if (this.isCcSelect > 0)
            user.ccuserid = user.userid;

          this.SelectedUsers.push(user);
          this.MapTouched = true;
          this.previousMailGrp = this.groupName;
        }
        else
          this.toastr.warning('Please select the user for To or Cc to map to the Group')

      }
      else {
        this.toastr.warning("User is already mapped to this group");
      }
      this.isToSelect = 0;
      this.isCcSelect = 0;
    }
    else {
      this.toastr.warning('Please select the user for To or Cc to map to the Group')
    }

  }

  setClickedUser(i, item) {
    this.maptype = null;
    this.currentgroup = i;
    //this.groupName = item.mailgroup;
    this.mailgroupId = item.mailgroupid;
    this.getMailGroupMappedList(item);
  }

  OpenConfirmforMapping(mailgrpname) {
    if (this.MapTouched || this.removeTouched) {


      let showpopup = this.dialogService.addDialog(CommondialogComponent,
        {
          title: 'Please Confirm',
          message: 'Would you like to save changes in Group ' + this.previousMailGrp,
          hclass: 'modelsuccess',
          oktext: 'Yes',
          canceltext: 'No',
          okshow: true,
          cancelshow: true
        }).subscribe((isConfirmed) => {
          if (isConfirmed) {

            this.SaveUserMapping();
            this.userMappingConfirmed = true

          }
          else {
            this.MapTouched = false;
            this.removeTouched = false;
            this.previousMailGrp = '';
            this.getMailGroupMappedList(this.selectedMailGrp)
          }

        });

    }
  }

  SaveUserMapping() {
    this.maptype = null;

    this.SelectedUsers.forEach((data, index) => {
      data.loadedfromdatabase = true;
      //data.createdby = +localStorage.getItem('userid');
      data.createdby = +this.localService.getJsonValue('userid');
    })
    if (this.SelectedUsers.length === 0) {
      //this.mailGroupDetail
      //this.mailGroupDetail.mailgroupid = 4
      this.mailGroupDetail.mailgroupid = this.mailgroupId
      this.mailgroupService.DeleteUserFromGroup(this.mailGroupDetail).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.ngOnInit();
              this.MapTouched = false;
              this.removeTouched = false;
              this.toastr.success('Mail Group saved successfully');
            }
            else {
              this.toastr.success('Error while removing the user from MailGroup');
            }
          }
        };
      },
        err => {
          this.toastr.error("Error while doing the operation");

        }
      )
    }

    if (this.SelectedUsers.length > 0) {

      this.mailgroupService.postMailgroupMapping(this.SelectedUsers).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.ngOnInit();
              this.MapTouched = false;
              this.removeTouched = false;
              this.toastr.success('Mail Group saved successfully');
            }
            else {
              this.toastr.success('User already mapped to this Mail Group');
            }
          }
        };
      },
        err => {
          this.toastr.error("Error while doing the operation");

        }
      )
    }
  }

  cancelOperation() {
    this.maptype = null;
    this.SelectedUsers = this.SelectedUsers.filter(obj => typeof obj.loadedfromdatabase != 'undefined' || obj.loadedfromdatabase != null);

    this.MapTouched = false;
    this.removeTouched = false

  }

}
